/** Mediatip's declared currency is EUR. The euro symbol is unambiguous;
 * other symbols (especially $) must still be resolved through the API. */
export function getKnownStoreCurrency(symbol: string | undefined): 'EUR' | undefined {
  return symbol === '€' || symbol === 'EUR' ? 'EUR' : undefined;
}
